import contactLessPayment from './../../../../../assets/Navbar/contactless-payment.png';
import cryptoCurrencyImg from './../../../../../assets/Navbar/143.Cryptocurrency.png';
import { buildUrlUsingBase } from '../../../../../constants';

type OptionType<K = string> = {
    "buy": K
    "sell": K
    "sell-buy": K
}

type OptionLinkType = {
    label: string,
    id: string,
    to: string
}


type MenuOptionsType = {
    labels: OptionType,
    images: OptionType,
    headings: OptionType,
    subHeading: OptionType,
    cta: OptionType,
    mainCol: OptionType<OptionLinkType[]>,
    toolsCol: OptionType<OptionLinkType[]>,
    resourcesCol: OptionType<OptionLinkType[]>,
}


export const menuOpts: MenuOptionsType = {
    labels: {
        'buy': 'Buy',
        'sell': 'Sell',
        'sell-buy': 'Upsize'
    },
    images: {
        'buy': contactLessPayment,
        'sell': cryptoCurrencyImg,
        'sell-buy': contactLessPayment
    },
    headings: {
        'buy': 'Get Qualified',
        'sell': 'Instant Home Valuation',
        'sell-buy': 'Get Qualified'
    },
    subHeading: {
        'buy': 'See how much down payment Zown can provide to you.',
        'sell': 'Get to see a detailed valuation of your home with key insights',
        'sell-buy': 'See how much down payment Zown can provide to you.'
    },
    cta: {
        'buy': buildUrlUsingBase('buyer/down-payment-qualification'),
        'sell': buildUrlUsingBase('seller/instant-home-valuation'),
        'sell-buy': buildUrlUsingBase('buyer/down-payment-qualification'),
    },
    mainCol: {
        'buy': [
            { 
                label: 'Down Payment Program',
                id: 'down-payment',
                to:  buildUrlUsingBase('buyer#upfront-down-payment-assistance')
            },
            {
                label: 'How It Works',
                id: 'how-it-works',
                to:buildUrlUsingBase('buyer/how-it-works')
            },
            {
                label: 'Why Zown',
                id: 'why-zown',
                to: buildUrlUsingBase('buyer#why-zown')
            },
            {
                label: "What's the Catch?",
                id: 'whats-the-catch',
                to: buildUrlUsingBase('buyer#whats-the-catch')
            },
            {
                label: 'FAQs',
                id: 'faqs',
                to: buildUrlUsingBase('buyer#faqs')
            }
        ],
        'sell': [
            {
                label: 'Selling With Zown',
                id: 'selling-with-zown',
                to: buildUrlUsingBase('seller#selling-with-zown')
            },
            {
                label: 'Why Sell with Zown',
                id: 'why-sell-with-zown',
                to: buildUrlUsingBase('seller#why-sell-with-zown')
            },
            {
                label: 'How It Works',
                id: 'how-it-works',
                to: buildUrlUsingBase('seller#how-it-works')
            },
            {
                label: 'FAQs',
                id: 'faqs',
                to: buildUrlUsingBase('seller#faqs')
            }
        ],
        'sell-buy': [
            {
                label: 'Upsizing with Zown',
                id: 'upsizing-with-zown',
                to: buildUrlUsingBase('upsize#upsizing-with-zown')
            },
            {
                label: 'Why Zown',
                id: 'why-upsize-with-zown',
                to: buildUrlUsingBase('upsize#why-upsize-with-zown')
            },
            {
                label: 'How It Works',
                id: 'how-it-works',
                to: buildUrlUsingBase('upsize#how-it-works')
            },
            {
                label: 'FAQs',
                id: 'faq',
                to: buildUrlUsingBase('upsize#faq')
            }
        ]
    },
    toolsCol: {
        'buy': [
            {
                label: 'Browse Homes',
                id: 'browse-homes',
                to: buildUrlUsingBase('')
            },
            {
                label: 'Affordability Calculator',
                id: 'affordability-calculator',
                to: buildUrlUsingBase('calculator/home-affordability')
            },
            {
                label: 'Affordability Map',
                id: 'affordability-map',
                to: buildUrlUsingBase('buyer/affordability-map')
            },
            {
                label: 'Mortgage Pre-Qualification',
                id: 'mortgage-pre-qualification',
                to: buildUrlUsingBase('buyer/mortgage-pre-qualification')
            }
        ],
        'sell': [
            {
                label: 'Instant Home Valuation',
                id: 'instant-home-valuation',
                to: buildUrlUsingBase('seller/instant-home-valuation')
            },
            {
                label: 'Sell Cost Calculator',
                id: 'sell-cost-calculator',
                to: buildUrlUsingBase('calculator/home-selling-cost')
            },
            {
                label: 'Commission Calculator',
                id: 'commission-calculator',
                to: buildUrlUsingBase('calculator/commissions')
            }
        ],
        'sell-buy': [
            {
                label: 'Instant Home Valuation',
                id: 'instant-home-valuation',
                to: buildUrlUsingBase('seller/instant-home-valuation')
            },
            {
                label: 'Browse Homes',
                id: 'browse-homes',
                to: 'https://homes.zown.ca/'
            },
            {
                label: 'Sell Cost Calculator',
                id: 'sell-cost-calculator',
                to: buildUrlUsingBase('calculator/home-selling-cost')
            },
            {
                label: 'Affordability Map',
                id: 'affordability-map',
                to: buildUrlUsingBase('buyer/affordability-map')
            }
        ]
    },
    resourcesCol: {
        'buy': [
            {
                label: 'Home Buying Guide',
                id: 'home-buying-guide',
                to: buildUrlUsingBase('buyer/home-buying-guide')
            },
            {
                label: 'Mortgage Rates',
                id: 'mortgage-rates',
                to: buildUrlUsingBase('buyer/mortgage-rates')
            },
            {
                label: 'Case Studies',
                id: 'case-studies',
                to: buildUrlUsingBase('buyer/case-studies')
            },
            {
                label: 'Current Offers',
                id: 'current-offers',
                to: buildUrlUsingBase('buyer/current-offers')
            },
            {
                label: 'Financial Zown',
                id: 'financial-zown',
                to: 'https://www.linkedin.com/newsletters/the-financial-zown-7083899114496675841'
            },
            {
                label: 'Contact Us',
                id: 'contact-us',
                to: buildUrlUsingBase('contact-us')
            }
        ],
        'sell': [
            {
                label: 'Checklist to Sell',
                id: 'checklist-to-sell',
                to: buildUrlUsingBase('seller/home-selling-checklist')
            },
            {
                label: 'Financial Zown',
                id: 'financial-zown',
                to: 'https://www.linkedin.com/newsletters/the-financial-zown-7083899114496675841'
            },
            {
                label: 'Contact Us',
                id: 'contact-us',
                to: buildUrlUsingBase('contact-us')
            }
        ],
        "sell-buy": [
            {
                label: 'Checklist to Sell',
                id: 'checklist-to-sell',
                to: buildUrlUsingBase('seller/home-selling-checklist')
            },
            {
                label: 'Mortgage Rates',
                id: 'mortgage-rates',
                to: buildUrlUsingBase('buyer/mortgage-rates')
            },
            {
                label: 'Case Studies',
                id: 'case-studies',
                to: buildUrlUsingBase('buyer/case-studies')
            },
            {
                label: 'Financial Zown',
                id: 'financial-zown',
                to: 'https://www.linkedin.com/newsletters/the-financial-zown-7083899114496675841'
            },
            {
                label: 'Contact Us',
                id: 'contact-us',
                to: buildUrlUsingBase('contact-us')
            }
        ]
    }
}